export const WIZARD_CONTAINER_ELEMENT_ID = 'WIZARD_CONTAINER';
export const WIZARD_COMPONENT_CONTAINER_ELEMENT_ID = 'WIZARD_COMPONENT_CONTAINER';
export const WIZARD_SCROLL_CONTAINER_ELEMENT_ID = 'WIZARD_SCROLL_CONTAINER';
export const FULLSTORY_MASK_CLASSNAME = 'fs-mask';

// For E2E tests
export const WIZARD_ACTIONS_ELEMENT_ID = 'WIZARD_ACTIONS';
export const WIZARD_DISCLAIMER_ELEMENT_ID = 'WIZARD_DISCLAIMER';
export const WIZARD_PROGRESS_ELEMENT_ID = 'WIZARD_PROGRESS';
export const WIZARD_EXPLANATION_BUBBLE_ELEMENT_ID = 'WIZARD_EXPLANATION_BUBBLE';
